import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
  FormGroup,
} from '@angular/forms';
import { Usuario } from './usuario';
import { AuthService } from '../../core/services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class LoginComponent implements OnInit, OnDestroy {
  public message = new BehaviorSubject<string>('');
  loginForm: FormGroup;
  usuario: Usuario;
  error: string;
  isAutenthicationError: boolean;

  constructor(
    private authorizeService: AuthService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) { }

  async ngOnInit() {
    if (typeof document !== 'undefined') {
      document.body.classList.add('login-page');
    }

    this.createForm(new Usuario());
  }

  ngOnDestroy(): void {
    if (typeof document !== 'undefined') {
      document.body.classList.remove('login-page');
    }
  }

  createForm(formLogin: any) {
    this.loginForm = new UntypedFormGroup({
      username: new UntypedFormControl(formLogin.username = "", Validators.required),
      password: new UntypedFormControl(formLogin.password = "", Validators.required),
    });
  }

  submitForm() {
  this.usuario = this.loginForm.value;

  this.authorizeService.login(this.usuario).subscribe({
    next: (res) => {

      const retUrl = this.activatedRoute.snapshot.queryParams['retUrl'];

      this.router.navigate([retUrl || 'adm/materia']);
    },

    error: (erro) => {
      this.error = erro.error.message;
      this.isAutenthicationError = true;
    }
  });
}
}
